import { Modal, ModalContent, Spinner } from "@heroui/react";
import { useTranslation } from "react-i18next";
import NiceModal, { useModal } from "@ebay/nice-modal-react";

export const SpinnerModal = NiceModal.create(() => {
  const { t } = useTranslation();
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      hideCloseButton={true}
      placement="center"
      backdrop="transparent"
      shouldBlockScroll={true}
      isDismissable={false}
      disableAnimation={true}
    >
      <ModalContent className="w-auto rounded-xl bg-black/70 p-6 text-white shadow-none">
        <Spinner
          variant="gradient"
          label={t("common:loading")}
          classNames={{
            circle1: "to-white",
            label: "text-white",
          }}
        />
      </ModalContent>
    </Modal>
  );
});
